// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6b7948bb","455":"c78f06a4","821":"ed048073"}[chunkId] + ".chunk.js";
};